// Typelizer digest c1aaf5aff2bb11a2378d30212c303164
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** DELETE /c/:company_id/recurring_invoices/:recurring_invoice_id/pause */
  destroy: (
    params: { recurringInvoiceId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/c/:company_id/recurring_invoices/:recurring_invoice_id/pause', params, options),
    method: 'delete',
  }),

  /** POST /c/:company_id/recurring_invoices/:recurring_invoice_id/pause */
  create: (
    params: { recurringInvoiceId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/recurring_invoices/:recurring_invoice_id/pause', params, options),
    method: 'post',
  }),
}
